const bookingNoCards = {
  html() {
    // Create null results and set attributes
    const nullResults = document.createElement('div');
    nullResults.classList.add('booking-filters__null-results');

    // Create label for null results container
    const nullResultsText = document.createTextNode(
      `${bookingNoCards.translate('null_results_message')}. `
    );

    // Create a element which is use to reset the store
    const nullResultResetLink = document.createElement('a');
    const nullResultResetLinkText = document.createTextNode(
      bookingNoCards.translate('reset_filters')
    );
    nullResultResetLink.setAttribute('href', '#');
    nullResultResetLink.appendChild(nullResultResetLinkText);

    // Append label and a element to null results
    nullResults.appendChild(nullResultsText);
    nullResults.appendChild(nullResultResetLink);

    // Add event listener for reset the store
    nullResultResetLink.addEventListener('click', () => {
      const resetEvent = new CustomEvent('booking-filter:reset');
      document.dispatchEvent(resetEvent);
    });

    // Hide booking calendar
    const renderNullResults = new CustomEvent('booking-filter:null-results');
    document.dispatchEvent(renderNullResults);

    return nullResults;
  },

  translate(key) {
    return window.I18n.translate(`js.modules.browse.booking_filters.${key}`);
  },

  appendTo(targetSelector) {
    const targetNode = document.querySelector(targetSelector);
    const html = bookingNoCards.html();
    targetNode.appendChild(html);
  },
};

module.exports = bookingNoCards;
